class PttService {
    constructor($rootScope, $q, $log, $timeout, wtcpjsClientProviderService, channelId, channelModel, endpointStatusService) {
        this.channelId = channelId;
        this.client = wtcpjsClientProviderService.getClient;
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$q = $q;
        this.channelModel = channelModel;
        this.endpointStatusService = endpointStatusService;
        this.pttState = 'off';
        this.pttRetryCnt = 0;
    }

    /* PUBLIC METHODS */
    pttStart() {
        let _this = this;
        if (this._pttInit()) {

            _this.client().PTTDown([_this.channelId])
                .then((data) => {
                    _this.pttRetryCnt = 0;
                    _this._notifyPttStarted();
                    _this.$rootScope.$applyAsync(function () {
                        if (data.channelResponses.length > 0 && _this.pttState === 'pending') {
                            _this._processPttResponse(data.channelResponses[0], 'PTTDown');
                        }
                    });
                })
                .catch((err) => {
                    if (err.errorCode !== 7001 || _this.pttRetryCnt === 3) {
                        _this.pttRetryCnt = 0;
                        _this._pttError('PTTDown', err);
                    } else if (_this.pttState !== 'stopping') {
                        _this.pttRetryCnt++;
                        _this.$timeout(() => _this.pttStart(), 500);
                    }
                });
        } else {
            this.pttStop();
        }
    }

    pttStop() {
        this.$log.debug('PTTService.pttStop started');
        if (this.isPttStarted()) {
            this.pttOffHandler && this.pttOffHandler();
            this._pttStopImplementation();
            this.$rootScope.$broadcast('pttStopped', this.channelId);
        }

        if (this.pttState === 'rejected') {
            this._stopped();
        }
    }

    callTooLong() {
        this.pttStop();
        this._pttError('CallPTTOff', 'PTT Too long');
    }

    isPttStarted() {
        return this.pttState === 'pending' || this.pttState === 'on';
    }

    isPttOn() {
        return this.pttState === 'on';
    }

    canTransmitAudio() {
        return this.client().WTCPAudioStatus.status === 'ready' &&
            this.channelModel.getChannel(this.channelId).canTransmitAudio;
    }

    isRxOnlyChannel() {
        return this.channelModel.getChannel(this.channelId).isRxOnlyChannel;
    }

    // images/icons/icon_ptt_{{status.getPttIconName()}}.png
    getPttIconName(isChannelSelected) {
        // Sync with other thin client(ios/android behavior) behavior
        // don't diable PTT button on simplex channel and someone else is speaking
        // If current user has an equal or lower priority than the speaker, I will be bonked out.

        //this.$log.info(`#${this.channelId} state: ${this.pttState}, isChannelSelected: ${isChannelSelected}`);
        switch (this.pttState) {
            case 'rejected': return 'bonk'; break;
            case 'pending': return 'requesting'; break;
            case 'stopping': return 'disabled'; break;
            case 'on': return !isChannelSelected; break; // returns 'true' or 'false'
            case 'off': return isChannelSelected; break;
        }
    }

    destroy() {
        //this.$log.debug("PttService.destroy for channel: #" + this.channelId);
        if (this.pttOffHandler) {
            this.pttOffHandler();
        }
    }

    /* PRIVATE METHODS */
    _isSomeoneSpeakingOnSimplexChannel(channelId) {
        return this.channelModel &&
            this.channelModel.getChannel(channelId) &&
            this.channelModel.getChannel(channelId).isSimplex &&
            this.endpointStatusService.isAnyoneSpeakingOnChannel(channelId);
    }

    _notifyPttStarted() {
        this.$rootScope.$broadcast('pttStarted', this.channelId);
    }

    _pttInit() {

        if (this.pttState === 'stopping') { // do nothing
            this.$log.warn("tried to PTT while stopping");
            return false;
        }

        this._pending();

        this.pttOffHandler = this.$rootScope.$on('wtcpjsService.pttOff', () => {
            this._playSound('error');
            this.pttStop();
        });

        return true;
    }

    _processPttResponse(response, pttType) {
        if (response.errorCode === 0 && response.errorMessage === 'OK') {
            this._enabled();
        } else {
            this.$log.debug(pttType + ' returned error', response);
            this._rejected(pttType);
        }
    }

    _pttError(pttType, err) {
        this.$log.error(pttType + ' exception', err);
        this._rejected(err);
    }

    _pttStopImplementation() {
        this.client().PTTUp()
            .then(() => {
                this.$log.info("Sucessfully received from PTTUp");
                console.log("Successful PTTUp <-");
                this._stopped(); 
            })
            .catch((err) => { this._pttError('PTTUp', err);
                              console.log("Reject PTTup <-");
                           }); 
        this.$log.info("Start to stopping the PTTUP()->");
        this._stopping();
     }


    _pending() {
        this.pttState = 'pending';
        this._playSound('trying');
    }

    _enabled() {
        this.pttState = 'on';
        this._playSound('grant');
    }

    _rejected(error) {
        this.pttState = 'rejected';
        this._playSound('error');
        if (!this.$rootScope.$$phase) {
            this.$rootScope.$apply();
        }
        this.$timeout(() => this._stopped(), 2000);
    }

    _stopped() {
        this.pttState = 'off';
        this.$log.debug('stopped PTT');
    }

    _stopping() {
        this.pttState = 'stopping';
        this.$log.debug('stopping PTT');
    }

    _playSound(soundFileName) {
        let src = `sounds/ptt_${soundFileName}.mp3`;
        let audio = new Audio(src);
        return new Promise((resolve, reject) => {
            let p = audio.play();
            if(p) {
                p
                    .then(() => {
                        var dur = (Math.ceil(audio.duration * 1000));
                        setTimeout(resolve, dur);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            } else {
                resolve();
            }
        });
    }
}

class PrivateCallPttService extends PttService {
    constructor($rootScope, $q, $log, $timeout, wtcpjsClientProviderService, channelId, channelModel) {
        super($rootScope, $q, $log, $timeout, wtcpjsClientProviderService, channelId, channelModel);
        this.channel = this.channelModel.getChannel(channelId);
    }

    pttStart() {
        let _this = this;
        if (this._pttInit()) {

            _this.client().callPTTOn(_this.channel.callId).then((data) => {
                _this._notifyPttStarted();
                _this.$rootScope.$applyAsync(function () {
                    if (_this.pttState === 'pending') {
                        _this._processPttResponse(data, 'callPTTOn');
                    }
                });
            }).catch((err) => _this._pttError('callPTTOn', err));
        } else {
            this.pttStop();
        }
    }

    _pttStopImplementation() {
        this.client().callPTTOff(this.channel.callId)
            .then(() => this._stopped())
            .catch((err) => { this._pttError('PTTUp', err); });
        this._stopping();
    }

    canTransmitAudio() {
        return this.client().WTCPAudioStatus.status === 'ready' && this.channel.callActive;
    }
}

angular
    .module('webcomm')
    .factory('pttService',
        ['$rootScope', '$q', '$log', '$timeout', 'wtcpjsClientProviderService', 'channelModel', 'endpointStatusService',
            function ($rootScope, $q, $log, $timeout, wtcpjsClientProviderService, channelModel, endpointStatusService) {
                return {
                    create(channelId) {
                        return new PttService($rootScope, $q, $log, $timeout, wtcpjsClientProviderService, channelId, channelModel, endpointStatusService);
                    }
                };
            }])
    .factory('privateCallPttService',
        ['$rootScope', '$q', '$log', '$timeout', 'wtcpjsClientProviderService', 'channelModel', 'endpointStatusService',
            function ($rootScope, $q, $log, $timeout, wtcpjsClientProviderService, channelModel, endpointStatusService) {
                return {
                    create(channelId) {
                        return new PrivateCallPttService($rootScope, $q, $log, $timeout, wtcpjsClientProviderService, channelId, channelModel, endpointStatusService);
                    }
                };
            }])